import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => {
  return createStyles({
    content: {
      margin: '2rem 0',
    },
  });
});
